import createComponent from './create-component';

const constructDialog = (dialogProperties, childTag, childProperties) => {
	const dialog = createComponent('x-dialog', dialogProperties);
	const childElement = createComponent(childTag, childProperties);

	dialog.setBodyComponent(childElement);
	document.body.append(dialog);
};

export default constructDialog;
